import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';

class ActivateForm extends React.Component {
  state = {
    name: '',
    passcode: '',
    description: '',
    open: true
  }

  handleOpen = () => {
    this.setState({open: true});
  };

  handleClose = () => {
    this.setState({open: false});
  };
  handleChange = (e) => {
    switch (e.target.name) {
      case 'email_addr':
        this.setState({name: e.target.value});
        break;
      case 'employee_number':
        this.setState({passcode: e.target.value});
        break;
      case 'description':
        this.setState({description: e.target.value});
        break;
      default:
        break;
    }
  };
  handleSubmit = () => {
    this.props.onSendSubmit(this.state);
  };
  render = () => {
    const requireActivate = this.props.requireActivate;
    if (!requireActivate) {
      return (<div></div>);
    }
    const textFieldStyle = {width: "300px"};
    return (
      <Dialog
        aria-labelledby="alert-dialog-title"
        modal={true}
        open={this.state.open}
      >
        <DialogTitle id="alert-dialog-title">{"許可されていないクライアントです。"}</DialogTitle>
        <DialogContent>
          <div>
          使用制限を設けております。<br/>TVMockを利用するには、下記情報の登録が必要です。
          </div>
          <form className="sendForm">
            <FormControl>
              <TextField
                name="email_addr"
                style={textFieldStyle}
                helperText="メールアドレスの@より前の部分"
                label="ユーザ名"
                value={this.state.name}
                onChange={this.handleChange.bind(this)}
                tabIndex="1"
              />
            </FormControl>
            <FormControl>
              <TextField
                name="employee_number"
                style={textFieldStyle}
                value={this.state.passcode}
                label="社員番号"
                onChange={this.handleChange.bind(this)}
                tabIndex="2"
              />
            </FormControl>
            <FormControl>
              <TextField
                name="description"
                style={textFieldStyle}
                value={this.state.description}
                label="任意文字列"
                helperText="PC名等"
                tabIndex="3"
                onChange={this.handleChange.bind(this)} />
            </FormControl>
          </form>
        </DialogContent>
        <DialogActions>
          <Button
            color="primary"
            onClick={this.handleSubmit}
            tabIndex="4"
          >登録</Button>
        </DialogActions>
      </Dialog>
    );
  };
};
export default ActivateForm;



// WEBPACK FOOTER //
// ./src/components/ActivateForm.js